import React, { useEffect, useState } from "react";
import { Row, Col, Spinner, Alert } from "react-bootstrap";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config.json";
import DocumentList from "./DocumentList";

const ESGDocumentLibrary = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDocuments = async () => {
    setLoading(true);
    setError(null);
    let docType = ['ESG_DOCUMENT_LIBRARY']

    try {
      const { isSuccess, data } = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}documents`,
        {},
        {documentType:JSON.stringify(docType)},
        "GET"
      );

      if (isSuccess && data?.documents) {
        setDocuments(data.documents);
      } else {
        setError("Failed to load documents");
      }
    } catch {
      setError("Something went wrong while fetching documents");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  return (
    <div className="document-management-page">
      <Row className="m-0">
        <Col xs={2} className="p-0">
          <Sidebar activePage="documents" />
        </Col>

        <Col xs={10} className="p-0">
          <Header />

          <div className="content-wrapper p-4">
          

            {error && <Alert variant="danger">{error}</Alert>}

            {loading ? (
              <div className="text-center p-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <DocumentList
                documents={documents}
                onRefresh={fetchDocuments}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ESGDocumentLibrary;
